import { supabaseClient } from 'supabase'
import { requireDecided } from './deskDecisionError'

export type SaveRejectNoteParams = {
  id: number
  note: string
}

/**
 * Save the optional free-text note on a rejected candidate (`desk_reject_note`,
 * D-10). The RPC trims it.
 *
 * Errors are thrown raw; a `false` result throws DeskAlreadyDecidedError (D-11).
 */
export const saveRejectNote = async ({ id, note }: SaveRejectNoteParams): Promise<true> => {
  const { data, error } = await supabaseClient.rpc('desk_reject_note', {
    p_id: id,
    p_note: note
  })

  if (error) {
    throw error
  }
  return requireDecided('desk_reject_note', data)
}
